import React, { useState } from "react";
import CurrencyFormat from "react-currency-format";
const moment = require("moment");

const OutstandingPayments = (props) => {
  const [ordersFilter, filterOrders] = useState({
    filter: "",
  });
  const applyFilter = (obj) => {
    if (!ordersFilter?.filter) return true;

    const filterTokens = ordersFilter.filter.toLowerCase().split(" ");
    let validOrder = true;

    for (const token of filterTokens) {
      if (token === "") continue;

      const matchFound =
        obj?.orderid?.toLowerCase()?.includes(token) ||
        obj?.collectiondate?.toLowerCase()?.includes(token) ||
        obj?.idnumber?.toLowerCase()?.includes(token) ||
        obj?.email?.toLowerCase()?.includes(token) ||
        obj?.firstname?.toLowerCase()?.includes(token) ||
        obj?.description?.toLowerCase()?.includes(token) ||
        obj?.promocode?.toLowerCase()?.includes(token) ||
        obj?.mobilenumber?.toLowerCase()?.includes(token) ||
        obj?.sellingprice?.toString()?.includes(token) ||
        obj?.source_?.toLowerCase()?.includes(token) ||
        obj?.tripdistance?.toString()?.includes(token) ||
        obj?.trips?.toString()?.includes(token) ||
        obj?.trucktype?.toLowerCase()?.includes(token) ||
        obj?.driverfirstname?.toLowerCase()?.includes(token) ||
        obj?.driverlastname?.toLowerCase()?.includes(token) ||
        moment(obj?.collectiondate)
          .format("MMMM")
          ?.toLowerCase()
          ?.includes(token) ||
        obj?.licenseplatenumber?.toLowerCase()?.includes(token);

      validOrder = validOrder && matchFound;
      if (!validOrder) break;
    }

    return validOrder;
  };

  // When the close button is clicked, set a reminder cookie that expires after 1 hour.
  const handleClose = () => {
    document.cookie = "reminder=true; max-age=3600";
    props?.setShowPaymentModal(false);
  };
  const getImage = (trucktype) => {
    try {
      return `https://media.qiktruck.co.za/3d-${trucktype}.png`;
    } catch (error) {
      return "";
    }
  };
  return (
    <div>
      {props?.showPaymentModal && (
        <div id="outstanding-payments-modal">
          <h2>
            Outstanding Payments:{" "}
            <CurrencyFormat
              value={
                props?.payments
                  ?.filter((obj) => applyFilter(obj))
                  ?.reduce((a, b) => a + (parseFloat(b.sellingprice) || 0), 0) /
                100
              }
              displayType={"text"}
              thousandSeparator={true}
              prefix={"R"}
              decimalScale={2}
              className="bold-price red"
            />
            <button
              id="close-button"
              onClick={handleClose}
              style={{ display: "block" }}
            >
              X
            </button>
          </h2>
          <p className="instructions ">
            <input
              className="search-payments"
              placeholder="Search for anything on a job"
              onChange={(e) =>
                filterOrders({
                  ...ordersFilter,
                  filter: e.target.value,
                })
              }
            />
          </p>
          <ul className="listings">
            {props?.payments?.length === 0 ? (
              <div />
            ) : (
              [...props?.payments]
                .reverse()
                ?.filter((obj) => applyFilter(obj))
                ?.map((p) => {
                  let date = moment(p?.collectiondate);
                  return (
                    <li className="outstanding-payment" key={p.orderid}>
                      <div className="p-trucktype">
                        <CurrencyFormat
                          value={p?.sellingprice / 100}
                          displayType={"text"}
                          thousandSeparator={true}
                          prefix={"R"}
                          decimalScale={2}
                          className="bold-price"
                        />{" "}
                        <span>{date.format("ddd D MMM YYYY")}</span>
                        <img src={getImage(p?.trucktype)} alt="" height="40" />
                      </div>
                      <div className="p-customer">
                        <span>
                          <b>Driver</b>: {p.driverfirstname} {p.driverlastname}
                          {" - "}
                          <a href={`tel:${p?.drivermobilenumber}`}>
                            <i className="mdi mdi-phone"></i>
                            {p.drivermobilenumber}
                          </a>
                        </span>
                      </div>
                      <div className="p-driver">
                        <span>
                          <b>Customer</b>: {p?.firstname} {p?.lastname} -{" "}
                          <a href={`tel:${p?.mobilenumber}`}>
                            <i className="mdi mdi-phone"></i>
                            {p?.mobilenumber}
                          </a>
                        </span>
                        <span>
                          {p?.orderid.split("-")[0]}, {p?.trucktype},{" "}
                          {parseFloat(p?.tripdistance / 1000).toFixed(2)}km
                        </span>
                      </div>
                      {p?.collectionaddress && (
                        <span className="addr">
                          {p?.collectionaddress} {" - > - "}
                          {p?.deliveryaddress}
                          <br />
                          <i>{p?.description.substring(0, 100)}</i>
                        </span>
                      )}
                    </li>
                  );
                })
            )}
          </ul>
        </div>
      )}
    </div>
  );
};

export default OutstandingPayments;
